<template>
  <div class="comment-form">
    <div class="metadata">
      <img v-if="auth.photoURL" :src="auth.photoURL" class="avatar"></img>
      <v-icon v-else x-large class="avatar default-avatar">account_circle</v-icon>

      <span>{{ auth.displayName }}</span>
    </div>
    <textarea ref="text"
      autofocus
      v-model="text"
      @keyup.ctrl.enter="post"
    ></textarea>
    <!-- <v-text-field
          name="text"
          label="Comment"
          value=""
          textarea
          v-model="text"
        ></v-text-field> -->
    <div class="links">
      <v-btn outline @click="post">Написати</v-btn>
      <v-btn flat @click="cancel">Скасувати</v-btn>
    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import moment from 'moment';
import { createComment } from '@/firebase/helper';

export default {
  name: 'comments-form',
  props: {
    postId: {
      required: true,
    },
    auth: {
      required: true,
      type: Object,
    },
    parentComment: {
      type: Object,
    },
  },
  data() {
    return {
      text: '',
    };
  },
  methods: {
    post() {
      if (!this.text) {
        return;
      }

      const comment = {
        text: this.text,
        author: {
          uid: this.auth.uid,
          name: this.auth.displayName,
          photoUrl: this.auth.photoURL,
        },
        postId: this.postId,
        timestamp: moment().valueOf(),
        date: moment().format('DD.MM.YYYY HH:mm'),
      };

      if (this.parentComment) {
        comment.parentId = this.parentComment.id;

        const parentParents = this.parentComment.parents || {};
        comment.parents = { ...parentParents, [this.parentComment.id]: true };
      }

      createComment(comment).then(() => {
        this.text = '';
      });
      this.cancel();
    },
    cancel() {
      this.$emit('cancel');
    },
  },
  mounted() {
    Vue.nextTick(() => {
      this.$refs.text.focus();
    });
  },
};

</script>

<style scoped>

.avatar {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  margin-right: 10px;
}

textarea {
  width: 100%;
  height: 50px;
  margin: 15px 0;
  outline: none;
  border: none;
}

.links .btn {
  margin: 0;
}

.metadata {
  color: #777;
  /*font-size: 16px;*/
}

.metadata .avatar {
  margin-right: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/Comments/CommentForm.vue